import "98.css";
import { useState, useEffect } from "react"

export default function Settings({onClose}) {

    useEffect(() => {
        clearActiveWindow();
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="Settings"]'));

        return () => {
            //console.log('clearing interval');
            //clearInterval(imageRotater)
        };
    }, []);

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function reOpen(selector) {
    
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.getAttribute('data-name');
        //console.log(selector)
        //console.log(selector.nodeName)

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;
        
        //Toolbar tab buttons
        if (selector.nodeName === 'BUTTON' && selector.classList.contains('toolbar-tab')) {
            dataName = selector.getAttribute('data-name');
            if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                selector.ariaSelected = 'true';
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            }
        } else {
            selector = selector.closest('.window');
            dataName = selector.getAttribute('data-name');
        }

        clearActiveWindow();
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));

    }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    return (
        <>

        <div className="window active" data-name="Settings" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">Settings</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Settings"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="Settings"></button>
                </div>
            </div>
            <div className="window-body">
                <div>
                    <p>Theme</p>
                    <div>Select your theme:</div>
                    <select id="theme-select"> 
                        <option>Pacific</option>
                        <option>Sexy</option>
                    </select>
                </div>
            </div>
        </div>

        </> 
    )
}